import { DumbbellIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@repo/ui/lib/utils';

export const GenericError: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation(['common']);

  return (
    <div
      className={cn(
        'container mx-auto max-w-md p-8 flex flex-col justify-center h-screen gap-6 items-center',
        className
      )}
    >
      <DumbbellIcon className="size-24 text-muted-foreground" />
      <div className=" flex items-center gap-2 text-2xl text-muted-foreground text-center">
        <span>{t('an-error-occurred')}</span>
      </div>
    </div>
  );
};
